import React from "react";

/**
 * Cloudflare Zero Trust (Access) 専用のラッパー
 * 認証はネットワークレイヤーで完了しているため、ここでは常に子要素を表示します。
 */
export const CloudflareAuthWrapper = ({ children }: { children: React.ReactNode }) => {
  return <React.Fragment>{children}</React.Fragment>;
};
